import { GetterTree } from "vuex";
import { RootState } from "../types";
import { kidState } from "./types";

export const getters: GetterTree<kidState, RootState> = {};
